const pageTitles = {
    PURCHASE_WIDGET_SDK: "Paid Health Report purchase Widget",
    PURCHASE_WIDGET_SDK_ERROR: "Paid Health Report purchase Widget Error",
};

export default pageTitles;
